import { render, staticRenderFns } from "./BulkShipmentDestinationEditDialog.vue?vue&type=template&id=7d16ffbd&scoped=true&"
import script from "./BulkShipmentDestinationEditDialog.vue?vue&type=script&lang=ts&"
export * from "./BulkShipmentDestinationEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BulkShipmentDestinationEditDialog.vue?vue&type=style&index=0&id=7d16ffbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d16ffbd",
  null
  
)

export default component.exports